import { useMemo } from 'react';
import { TimeUnit } from '@mews/enums';
import { DurationUtils } from '@mews/framework';
import { getBookablePeriod, isDayUse, isHourUse, isMonthUse, isNightUse } from '@mews-commander/utils';
import { BookablePeriod, TimeUnitPeriod } from '@mews-commander/data-access';
import { isAdditionalService, isBookableService } from '../ducks/servicesNew';
import { useService } from './useService';

export const useServiceInfo = (serviceId: string | undefined | null) => {
    const service = useService(serviceId);
    const bookableService = service && isBookableService(service) ? service : undefined;
    const additionalService = service && isAdditionalService(service) ? service : undefined;

    const endOffset = bookableService?.data.value.endOffset;
    const isOverlappingTimeUnit = endOffset ? DurationUtils.isOverlappingNextTimeUnit(endOffset) : false;

    return useMemo(
        () => ({
            service,
            bookableService,
            additionalService,
            /** @deprecated use timeUnitPeriod */
            timeUnit: (bookableService?.data.value.timeUnit as TimeUnit) ?? TimeUnit.Day,
            timeUnitPeriod: bookableService?.data.value.timeUnitPeriod ?? TimeUnitPeriod.Day,
            bookablePeriod: bookableService ? getBookablePeriod(bookableService) : BookablePeriod.Day,
            isOverlappingTimeUnit,
            isDayUse: service && isDayUse(service),
            isNightUse: service && isNightUse(service),
            isMonthUse: service && isMonthUse(service),
            isHourUse: service && isHourUse(service),
        }),
        [service, bookableService, additionalService, isOverlappingTimeUnit]
    );
};
